/*
 * Copyright (c) 2026 American Association for Physician Leadership, Inc. All rights reserved.
 * Proprietary AAPL work product. See LICENSE.
 *
 * Hydrates the marketing pages: HubSpot forms load when their placeholder
 * scrolls near the viewport, one script for the whole page.
 */
(function () {
  var embeds = document.querySelectorAll('.mk-form__embed[data-hs-form]');
  if (!embeds.length) return;
  var loader = null;

  function load() {
    if (loader) return loader;
    loader = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://js.hsforms.net/forms/embed/v2.js';
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return loader;
  }

  function mount(el) {
    if (el.getAttribute('data-mounted')) return;
    el.setAttribute('data-mounted', '1');
    load().then(function () {
      var note = el.querySelector('.mk-form__note');
      if (note) note.remove();
      window.hbspt.forms.create({
        region: 'na1',
        portalId: el.getAttribute('data-hs-portal'),
        formId: el.getAttribute('data-hs-form'),
        target: '#' + el.id
      });
    }).catch(function () {
      var note = el.querySelector('.mk-form__note');
      if (note) note.textContent = 'The form could not load. Refresh the page to try again.';
    });
  }

  Array.prototype.forEach.call(embeds, function (el, i) {
    if (!el.id) el.id = 'mk-hs-' + i;
  });
  function mountAll() {
    Array.prototype.forEach.call(embeds, mount);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          io.unobserve(entry.target);
          mount(entry.target);
        }
      });
    }, { rootMargin: '400px 0px' });
    Array.prototype.forEach.call(embeds, function (el) { io.observe(el); });
    // A hidden tab gets no intersection notifications; mount everything
    // once the page has settled, so a form never waits on the observer alone.
    window.setTimeout(mountAll, 4000);
  } else {
    mountAll();
  }
})();

/*
 * The learn page's quiz: the answers chosen in its form pick the recommendations
 * stored on the section (data-mk-quiz), keyed journey-time-style as on the website.
 */
(function () {
  document.querySelectorAll('[data-mk-quiz]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.getAttribute('data-mk-quiz')); } catch (e) { return; }
    var form = root.querySelector('.mk-quiz__form');
    var out = root.querySelector('.mk-quiz__results');
    var ui = data.ui || {};

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text) n.textContent = text;
      return n;
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var answers = data.order.map(function (id) {
        var c = form.querySelector('input[name="' + id + '"]:checked');
        return c ? c.value : '';
      });
      var recs = data.recommendations[answers.join('-')] || [];
      out.innerHTML = '';
      out.appendChild(el('h3', 'mk-quiz__results-title', ui.resultsTitle || ''));
      var grid = el('div', 'mk-quiz__recs');
      recs.forEach(function (r, i) {
        var card = el('article', 'mk-quiz__rec');
        var icon = data.icons[r.iconKey];
        if (icon && icon.url) {
          var img = el('img', 'mk-quiz__icon');
          img.src = icon.url;
          img.alt = icon.alt || '';
          card.appendChild(img);
        }
        if (i === 0 && ui.topRecommendationBadge) card.appendChild(el('p', 'mk-quiz__badge', ui.topRecommendationBadge));
        card.appendChild(el('h4', '', r.title));
        card.appendChild(el('p', '', r.description));
        if (r.cta && r.cta.url) {
          var a = el('a', 'mk-btn mk-btn--dark', r.cta.label);
          a.href = r.cta.url;
          card.appendChild(a);
        }
        grid.appendChild(card);
      });
      out.appendChild(grid);
      var tip = data.tips[answers[0]];
      if (tip) {
        var t = el('div', 'mk-quiz__tip');
        t.appendChild(el('p', '', tip.text));
        if (tip.cta && tip.cta.url) {
          var ta = el('a', '', tip.cta.label);
          ta.href = tip.cta.url;
          t.appendChild(ta);
        }
        out.appendChild(t);
      }
      var reset = el('button', 'mk-btn mk-btn--light', ui.resetLabel || 'Start Over');
      reset.type = 'button';
      reset.addEventListener('click', function () {
        out.hidden = true;
        form.hidden = false;
        form.scrollIntoView({ block: 'start' });
      });
      out.appendChild(reset);
      form.hidden = true;
      out.hidden = false;
      out.scrollIntoView({ block: 'start' });
    });
  });
})();
